import { createSlice } from 'utils/@reduxjs/toolkit';
import { ErpSystemState } from './types';
import { reducers } from './reducers';
import { LANGUAGE_ID_MAP } from '../constants';

const urlParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlParams);

export const initialState: ErpSystemState = {
  erpSystem: params?.erpSystem || 'NL',
  language: (params?.userLanguageCode || 'en').toLowerCase(),
  plantCode: params?.plantCode || null,
  salesDocumentNumber: params?.salesDocumentNumber || null,
  salesDocumentPosition: params?.salesDocumentPosition || null,
  sapUserId: params?.sapUserId || null,
  salesOrganization: params?.salesOrganization || null,
  customerNumber: params?.customerNumber ?? null,
  customerLanguageCode: params?.customerLanguageCode ?? null,
  sapConfigurationNumber: params?.sapConfigurationNumber || null,
  languageId: !!params?.userLanguageCode
    ? LANGUAGE_ID_MAP[params?.userLanguageCode.toLowerCase()]
    : -1,
  configurationId: params?.configurationId || null,
};

const slice = createSlice({
  name: 'erpSystem',
  initialState,
  reducers,
});

export const { actions: erpSystemActions } = slice;
export const { reducer: erpSystemReducer } = slice;
